import accountTransformer from './../../transformers/account'
import accountPermissionsTransformer from './../../transformers/permissions'
import store from './../../store'
import Vue from 'vue'
import notification from '../notification'

// When the request succeeds
const success = (account, permissions) => {
  store.dispatch('account/store', accountTransformer.fetch(account))
}

// Both requests are independent; fetching them in parallel halves the time
// the router guard blocks the first navigation.
export default () =>
  Promise.all([
    Vue.$http.get('/user/current/permissions/'),
    Vue.$http.get('/user/current/'),
  ])
    .then(([permissionsResponse, response]) => {
      store.dispatch('account/storePermissions', accountPermissionsTransformer.fetch(permissionsResponse.data))
      success(response.data)
      notification.connectSocket()
      notification.getNotifications()
      // Timeout based notifications, in case websocket fails
      notification.fetchNotifications()
    })



// WEBPACK FOOTER //
// ./src/services/account/find.js